var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-title",class:`base-title-${_vm.borderType}`,style:({color: _vm.fontColor}),attrs:{"title":_vm.title}},[_vm._v(" "+_vm._s(_vm.title)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }